<template>
	<div class="message_warpper">
		<div class="tabList">
			<div :class="activeName == 'Notice' ? 'isActive tab' : 'tab'" @click="tabName('Notice')">
				Notice
			</div>
			<div :class="activeName == 'Circulars' ? 'isActive tab' : 'tab'" @click="tabName('Circulars')">
				Circulars
			</div>
			
			<div :class="activeName == 'ATel' ? 'isActive tab' : 'tab'" @click="tabName('ATel')">
				ATel
			</div>
			 <div :class="activeName == 'Customize' ? 'isActive tab' : 'tab'" @click="tabName('Customize')">
				Customize
			</div> 
		</div>
		<div v-show="activeName == 'Notice'">
			<div class="eventstable">
				<el-table :data="NoticeList" style="width: 100%" :header-cell-style="{
            background: '#F0F3F8',
            height: '42px',
          }" @row-click="clickInfo" :row-style="rowStyle">
					<el-table-column v-for="item in NoticeListColumn" :key="item.key" :label="item.name"
						:prop="item.prop" :sortable="item.sort" :width="item.width" :align="item.align">
						<template slot-scope="scope">
							{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div v-show="activeName == 'Circulars'">
			<div class="eventstable">
				<el-table :data="CircularsList" :header-cell-style="{ background: '#F0F3F8' }" @row-click="clickInfo"
					:row-style="rowStyle">
					<el-table-column v-for="item in cularsListColumn" :key="item.key" :label="item.name"
						:prop="item.prop" :sortable="item.sort" :width="item.width" :align="item.align" header-align="center">
						<template slot-scope="scope">
							{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div v-show="activeName == 'ATel'">
			<div class="eventstable">
				<el-table :data="AtelList" :header-cell-style="{ background: '#F0F3F8' }" @row-click="clickInfo"
									:row-style="rowStyle">
					<el-table-column v-for="item in AtelListColumn" :key="item.key" :label="item.name"
													 :prop="item.prop" :sortable="item.sort" :width="item.width" :align="item.align" header-align="center">
						<template slot-scope="scope">
							{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div v-show="activeName == 'Customize'">
			<div class="eventstable">
				<el-table :data="CustomizeList" style="width: 100%" :header-cell-style="{ background: '#F0F3F8' }"
					@row-click="clickInfo" :row-style="rowStyle">
					<el-table-column v-for="item in CustomizeListColumn" width="180" :key="item.key" :label="item.name"
						:prop="item.prop" :sortable="item.sort">
						<template slot-scope="scope">
							{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pageBlock">
			<CuntPage @handleCurrentChanges="handchange" :pageSize="pageSize" :totalTwo="total" @handleSizeChange="sizeChange"
				:currentPage="currentPage"></CuntPage>
		</div>
	</div>
</template>
<script>
	import { format } from '../../utils/index.js'
	import CuntPage from "../../components/page/CuntPage";
	export default {
		name: "messageIndex",
		components: {
			CuntPage
		},
		props: {
			titles: {
				type: String,
				default: 'Notice'
			}
		},
		data() {
			return {
				activeName: "Notice",
				NoticeList: [],
				currentRowId: '',
				currentRowId2:'',
				total: 0,
				currentPage: 1,
				pageNo: 1,
				pageSize: 10,
				eventId:'',
				NoticeListColumn: [{
						prop: "noticeType",
						name: "Notice TYPE",
						width:"200",
						align:'center'
					},
					{
						prop: "eventName",
						name: "Event",
						width:"300",
						align:'center'
					},
					{
						prop: "triggerTime",
						name: "Trigger Time (UTC)",
						sort: true,
						width:"200",
						align:'center'
					},
					{
						prop: "telescope",
						name: "Telescope",
						sort: true,
						width:"200",
						align:'center'
					},
					{
						prop: "objectClass",
						name: "Class",
						width:"100",
						align:'center'
					},
					{
						prop: "ra",
						name: "RA",
						width:"100",
						align:'center'
					},
					{
						prop: "declination",
						name: "DEC",
						width:"100",
						align:'center'
					},
					{
						prop: "positioningError",
						name: "Loc_err (deg)",
						width:"180",
						align:'center'
					},
					{
						prop: "noticeDate",
						name: "Notice Time",
						width:"200",
						align:'center'
					},
				],
				CircularsList: [],
				cularsListColumn: [{
						prop: "number",
						name: "Circular Number",
						width:"200",
						align:'center',
					},
					{
						prop: "subject",
						name: "Subject",
						width:"600",
						align:'left',
					},
					{
						prop: "eventName",
						name: "Event",
						width:"200",
						align:'center'
					},
					{
						prop: "triggerTime",
						name: "Burst Time (UTC)",
						sort: true,
						width:"200",
						align:'center'
					},
					{
						prop: "telescope",
						name: "Telescope",
						width:"200",
						align:'center'
					},
					{
						prop: "objectClass",
						name: "Class",
						width:"100",
						align:'center'
					},
					{
						prop: "ra",
						name: "RA",
						width:"100",
						align:'center'
					},
					{
						prop: "declination",
						name: "DEC",
						width:"100",
						align:'center'
					},
					{
						prop: "positioningError",
						name: "Loc_err (deg)",
						width:"200",
						align:'center'
					},
					{
						prop: "circularTime",
						name: "Circular Time",
						width:"200",
						align:'center'
					},
				],
				AtelList:[],
				AtelListColumn: [{
					prop: "number",
					name: "ATel Number",
					width:"200",
					align:'center',
				},
					{
						prop: "title",
						name: "title",
						width:"600",
						align:'left',
					},
					{
						prop: "eventName",
						name: "Event",
						width:"200",
						align:'center'
					},
					{
						prop: "triggerTime",
						name: "Burst Time (UTC)",
						sort: true,
						width:"200",
						align:'center'
					},
					{
						prop: "telescope",
						name: "Telescope",
						width:"200",
						align:'center'
					},
					{
						prop: "objectClass",
						name: "Class",
						width:"100",
						align:'center'
					},
					{
						prop: "ra",
						name: "RA",
						width:"100",
						align:'center'
					},
					{
						prop: "declination",
						name: "DEC",
						width:"100",
						align:'center'
					},
					{
						prop: "positioningError",
						name: "Loc_err (deg)",
						width:"200",
						align:'center'
					},
					{
						prop: "atelTime",
						name: "ATel Time",
						width:"200",
						align:'center'
					},
				],
				CustomizeList: [],
				CustomizeListColumn: [
					// {
					// 	prop: "number",
					// 	name: "Circular Number",
					// },
					{
						prop: "title",
						name: "Title",
					},
					{
						prop: "eventName",
						name: "Events",
					},
					{
						prop: "triggerTime",
						name: "Burst Time (UTC)",
					},
					{
						prop: "telescope",
						name: "Telescope",
					},
					{
						prop: "objectClass",
						name: "Class",
					},
					{
						prop: "ra",
						name: "RA",
					},
					{
						prop: "declination",
						name: "DEC",
					},
					{
						prop: "positioningError",
						name: "Loc_err (deg)",
					},
					{
						prop: "createDate",
						name: "Time",
					}
				],
				id: this.$route.query.id,
				params:{
					telescope: [],
					ra: "",
					desc: "",
					beginTriggerTime: "",
					endTriggerTime: "",
					title: "",
					radius:'',
					pageNo: 1,
					pageSize: 10,
					eventId:''
				},
			};
		},
		methods: {
			tabName(tab) {
				this.activeName = tab;
				this.params.pageSize = this.pageSize
				this.params.pageNo = 1
				//跟随activeName切换调用不同接口
				if (this.activeName == "Notice") {
					this.getAstronNotice(this.params);
				} else if (this.activeName == "Circulars") {
					this.getAstronCircular(this.params);
				} else if (this.activeName == "Customize") {
					this.getAstronCustomize(this.params);
				}else if (this.activeName == "ATel") {
					this.getAstronAtel(this.params)

				}
			},
			handchange(e) {
				this.params.pageSize = this.pageSize
				this.params.pageNo = e
				this.pageNo = e
				this.tabNameTwo(this.params)
			},
			sizeChange(e) {
				this.pageSize = e
				this.params.pageNo = this.pageNo
				this.params.pageSize = e
				this.tabNameTwo(this.params)
			},
			tabNameTwo(parma) {
				console.log(123123123)
				if (this.activeName == "Notice") {
					this.getAstronNotice(parma);
				} else if (this.activeName == "Circulars") {
					this.getAstronCircular(parma);
				} else if (this.activeName == "Customize") {
					this.getAstronCustomize(parma);
				}else if (this.activeName == "ATel") {
					this.getAstronAtel(parma)

				}
			},
			getDataParm(parm) {
				console.log('请求了getData')
				parm = {
					pageNo: 1,
					pageSize: 10
				}
				if (this.activeName == "Notice") {
			 	this.getAstronNotice(parm);
				} else if (this.activeName == "Circulars") {
					this.getAstronCircular(parm);
				} else if (this.activeName == "Customize") {
					this.getAstronCustomize(parm);
				}else if (this.activeName == "ATel") {
					this.getAstronAtel(parm)

				}
			},
			getDataParm2(parm) {
				console.log('请求了getData2')
				this.params = parm
        this.pageSize = parm.pageSize;
				if (this.activeName == "Notice") {
					this.getAstronNotice(parm);
				} else if (this.activeName == "Circulars") {
					this.getAstronCircular(parm);
				} else if (this.activeName == "Customize") {
					this.getAstronCustomize(parm);
				} else if (this.activeName == "ATel") {
					this.getAstronAtel(parm)

				}
			},
			rowStyle({
				row,
				rowIndex
			}) {
				if (this.currentRowId2 === row.id) {
					// 此处返回选中行的样式对象，按需设置
					return {
						'color': '#168ec7',
						'font-weight': '700'
					}
				}
			},
			clickInfo(row, column, event) {
				console.log(this.currentRowId)
				console.log(row.id)
				if (this.currentRowId === row.id) return
				this.currentRowId = row.id
				this.currentRowId2 = row.id
				console.log(this.activeName)
				console.log(this.id)
				if (this.activeName == "Notice") {
					console.log(this.id !== row.id)
					if (this.id !== row.id) {
						this.id = row.id;
						let a = {
							activeName: 'Notice',
							id: this.id
						}
						console.log(1234)
						localStorage.setItem('metaTitle',this.$route.meta.title)
						if(localStorage.getItem('navActive') == 'MESSAGE'){
							let routedata = this.$router.resolve({
								path: "/Notice",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
							window.open(routedata.href, '_blank');
						}else{
							this.$router.push({
								path: "/Notice",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
						}
						this.$emit('getInfo', a)
						this.id = row.id;
					} else {
						return {};
					}
				} else if (this.activeName == "Circulars") {
					if (this.id !== row.id) {
						this.id = row.id;
						let a = {
							activeName: 'Circulars',
							id: this.id
						}
						localStorage.setItem('metaTitle',this.$route.meta.title)
						if(localStorage.getItem('navActive') == 'MESSAGE'){
							let routedata = this.$router.resolve({
								path: "/Circulars",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
							window.open(routedata.href, '_blank');
						}else{
							this.$router.push({
								path: "/Circulars",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
						}
						this.$emit('getInfo', a)
						this.id = row.id;
					} else {
						return {};
					}
				}else if (this.activeName == "ATel") {
					if (this.id !== row.id) {
						this.id = row.id;
						let a = {
							activeName: 'ATel',
							id: this.id
						}
						localStorage.setItem('metaTitle',this.$route.meta.title)
						if(localStorage.getItem('navActive') == 'MESSAGE'){
							console.log(12312312312)
							let routedata = this.$router.resolve({
								path: "/Atel",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
							window.open(routedata.href, '_blank');
						}else{
							this.$router.push({
								path: "/Atel",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
						}
						this.$emit('getInfo', a)
						this.id = row.id;
					} else {
						return {};
					}
				} else if (this.activeName == "Customize") {
					if (this.id !== row.id) {
						this.id = row.id;
						if(localStorage.getItem('navActive') == 'MESSAGE'){
							let routedata = this.$router.resolve({
								path: "/Customize",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
              // row.id;
              // this.$router.push({path:'submit',query:{constid:row.id}});
							window.open(routedata.href, '_blank');
						}else{
							this.$router.push({
								path: "/Customize",
								query: {
									id: row.id,
									activeName:this.activeName,
									currentRowId:this.currentRowId,
									eventId:row.eventId == ''?'0':row.eventId
								},
							});
						}
						this.id = row.id;
					} else {
						return {};
					}
				}
			},
			// Notice列表
			getAstronNotice(param) {
				if(localStorage.getItem('navActive') == 'MESSAGE'){
					
				}else{
					if(this.$route.query.eventId){
						param.eventId = this.$route.query.eventId
					}
				}
				this.$fetchGet("/cms-middle/astronNotice/search", param).then(
					(res) => {
						this.NoticeList = res.page.records;
						for (var i = 0; i < this.NoticeList.length; i++) {
							this.NoticeList[i].noticeDate = format(this.NoticeList[i].noticeDate,
								'yyyy-MM-dd hhh:mmm:sss')
						}
						this.total = res.page.total
					}
				);
			},
			//Circular列表
			getAstronCircular(param) {
				if(localStorage.getItem('navActive') == 'MESSAGE'){
					
				}else{
					if(this.$route.query.eventId){
						param.eventId = this.$route.query.eventId
					}
				}
					this.$fetchGet("/cms-middle/astronCircular/search", param).then(
						(res) => {
							this.CircularsList = res.page.records;
							this.total = res.page.total
							for (var i = 0; i < this.CircularsList.length; i++) {
								this.CircularsList[i].circularTime = format(this.CircularsList[i].circularTime,
									'yyyy-MM-dd hh:mm:ss')
							}
						}
					);
			},
			//Customize列表
			getAstronCustomize(param) {
				if(localStorage.getItem('navActive') == 'MESSAGE'){
					
				}else{
					if(this.$route.query.eventId){
						param.eventId = this.$route.query.eventId
					}
				}
				this.$fetchGet("/cms-middle/astronCustomize/search", param).then(
					(res) => {
						this.CustomizeList = res.page.records;
						for (var i = 0; i < this.CustomizeList.length; i++) {
							this.CustomizeList[i].createDate = format(this.CustomizeList[i].createDate,
								'yyyy-MM-dd hh:mm:ss')
						}
						this.total = res.page.total
					}
				);
			},
			// atel列表
			getAstronAtel(param) {
				if(localStorage.getItem('navActive') == 'MESSAGE'){

				}else{
					if(this.$route.query.eventId){
						param.eventId = this.$route.query.eventId
					}
				}
				this.$fetchGet("/cms-middle/astronAtel/search", param).then(
						(res) => {
							this.AtelList = res.page.records;
							this.total = res.page.total
							for (var i = 0; i < this.AtelList.length; i++) {
								if(this.AtelList[i].atelTime){
									this.AtelList[i].atelTime = format(this.AtelList [i].atelTime,
											'yyyy-MM-dd hh:mm:ss')
								}

							}
						}
				);
			},
			getDatas(){
				this.$emit('aaaa',123)
			},
			handleVisiable(){
				this.currentRowId = ''
				this.id = ''
			},
		},
		mounted() {
			this.getDatas()
			document.addEventListener('visibilitychange', this.handleVisiable)
		},
		created() {
			if(this.$route.query.currentRowId){
				this.currentRowId = this.$route.query.currentRowId
			}
			if(JSON.stringify(this.$route.query) != '{}'){
				if(this.$route.query.eventId){
					this.eventId = this.$route.query.eventId
				}else{
					this.eventId = '0'
				}
			}else{
				this.eventId = ''
			}
			console.log(this.titles)
			this.activeName = this.titles
			this.params.eventId = this.eventId
			this.tabNameTwo(this.params)
			
			// if (this.activeName == "Notice") {
			// 	this.getAstronNotice();
			// }
		},
	};
</script>
<style scoped lang="less">
	/deep/.el-table .tr-red {
		color: red !important;
	}

	.el-table {
		cursor: pointer;
	}

	.tabList {
		display: flex;
		height: 41px;
		margin-top: 32px;
	}

	.tab {
		flex: 1;
		border: 1px solid #e5e5e5;
		border-radius: 6px;
		text-align: center;
		line-height: 38px;
		font-size: 16px;
		font-family: Arial-Bold, Arial;
		font-weight: bold;
		cursor: pointer;
	}

	.tab.isActive {
		background: linear-gradient(90deg, #144072, #1680b7);
		border-radius: 6px;
		opacity: 1;
		border: 1px solid #ffffff;
		color: #fff;
	}
	.message_warpper{
		min-height: 400px;
	}
	.pageBlock {
		margin-top: 28px;
		height: 44px;
		display: flex;
		align-items: center;
		margin-bottom: 52px;
	}

	.pagination {
		margin: auto;
	}

	.eventstable {
		margin-top: 26px;
	}

	/deep/ .el-table__header tr,
	.el-table__header th {
		padding: 0;
		height: 40px;
	}

	/deep/ .el-table__header-wrapper {
		border-top: 3px solid #168ec7;
		/* height: 42px; */
		background: #f0f3f8 !important;
	}

	/deep/ .el-table__cell {
		// text-align: center;
		font-size: 11px;
		font-family: Alibaba Sans;
	}

	/deep/.el-table tr:nth-child(even) {
		background: #f7f9fb;
	}

	/deep/ .is-leaf {
		font-size: 14px;
		color: #168ec7;
		font-family: Alibaba Sans;
		font-weight: 800;
	}

	/deep/ .eventstable .el-table thead tr {
		height: 42px;
	}

	/deep/ .el-table .el-table__cell {
		padding: 9px 0 !important;
	}

	/deep/ .eventstable .el-table thead .el-table__cell {
		padding: 0 !important;
	}

	.el-icon-warning-outline {
		font-size: 18px;
		font-weight: bold;
		color: #1191cb;
	}
</style>
